<template>
    <div ref="widget"></div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    discussion: String,
    commentsLimit: Number,
    height: Number,
  },
  computed: {
    ...mapState(['theme']),
    primaryColor() {
      return getComputedStyle(document.body).getPropertyValue('--primary');
    },
  },
  methods: {
    init() {
      this.$refs.widget.innerHTML = '';

      const script = document.createElement('script');
      script.src = 'https://telegram.org/js/telegram-widget.js?22';
      script.async = true;
      script.dataset.telegramDiscussion = this.discussion;
      script.dataset.commentsLimit = this.commentsLimit;
      if (this.theme === 'dark') {
        script.dataset.dark = 1;
      }
      if (this.height) {
        script.dataset.height = this.height;
      }
      if (this.primaryColor) {
        script.dataset.color = this.primaryColor.slice(1);
      }

      this.$refs.widget.appendChild(script);
    },
  },
  watch: {
    discussion: 'init',
    commentsLimit: 'init',
    height: 'init',
    theme: 'init',
  },
  mounted() {
    this.init();
  },
};
</script>
